import { render, staticRenderFns } from "./RelaunchCosmoformDialog.vue?vue&type=template&id=950e9e7a&scoped=true"
import script from "./RelaunchCosmoformDialog.vue?vue&type=script&lang=js"
export * from "./RelaunchCosmoformDialog.vue?vue&type=script&lang=js"
import style0 from "./RelaunchCosmoformDialog.vue?vue&type=style&index=0&id=950e9e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950e9e7a",
  null
  
)

export default component.exports